import { ActionsEnum } from "../ActionsEnum";
import { MenuItemBasic } from "./MenuItemBasic";
import { MenuItemColor } from "./MenuItemColor";
import { MenuItemHideMesh } from "./MenuItemHideMesh";
import { MenuItemRunAnimation } from "./MenuItemRunAnimation";

export class MenuFactory {
  static createMenu(menuConfig) {
    let button;
    switch (menuConfig.actionType) {
      
      case ActionsEnum.CHANGE_COLOR:
        button = new MenuItemColor(
          null,
          null,
          null,
          menuConfig.actionType,
          null,
          null,
          menuConfig.targets,
          menuConfig.colors
        );
        return button
      case ActionsEnum.HIDE_MESH:
        button = new MenuItemHideMesh(
          null,
          null,
          null,
          menuConfig.actionType,
          null,
          null,
          menuConfig.meshes,
          menuConfig.visibility
        );
        return button
      case ActionsEnum.RUN_ANIMATIONS:
        button = new MenuItemRunAnimation(
          null,
          null,
          null,
          menuConfig.actionType,
          null,
          null,
          menuConfig.target,
          menuConfig.direction
        );
        return button
      default:
        button = new MenuItemBasic(
          menuConfig.name,
          menuConfig.mesh,
          null,
          menuConfig.actionType
        );
        return button
    }

  }
}